import { render, staticRenderFns } from "./goods-detail.vue?vue&type=template&id=1d9e1886&scoped=true&"
import script from "./goods-detail.vue?vue&type=script&lang=js&"
export * from "./goods-detail.vue?vue&type=script&lang=js&"
import style0 from "./goods-detail.vue?vue&type=style&index=0&id=1d9e1886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9e1886",
  null
  
)

export default component.exports